import React from "react";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import "./Header.css";
import logo from "../../assets/logo.png";

export const Header = () => {
  return (
    <section>
      <Navbar expand="lg">
        <Container>
          <Navbar.Brand href="#home">
            <img className="logoImage" src={logo} alt="Piyush Kesarwani" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link href="#about" className="text-light navLinks">
                <span>01.</span>About
              </Nav.Link>
              <Nav.Link href="#experience" className="ms-1 text-light navLinks">
                <span>02.</span>Experience
              </Nav.Link>
              <Nav.Link href="#projects" className="ms-1 text-light navLinks">
                <span>03.</span>Projects
              </Nav.Link>
              <Nav.Link href="#contact" className="ms-1 text-light navLinks">
                <span>04.</span>Contact
              </Nav.Link>
              <Nav.Link href="#" className="ms-1 text-light navLinks">
                <span>05.</span>My Blog
              </Nav.Link>
              {/* <NavDropdown title="Dropdown" id="basic-nav-dropdown">
                <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
                <NavDropdown.Item href="#action/3.2">
                  Another action
                </NavDropdown.Item>
                <NavDropdown.Item href="#action/3.3">
                  Something
                </NavDropdown.Item>
                <NavDropdown.Divider />
                <NavDropdown.Item href="#action/3.4">
                  Separated link
                </NavDropdown.Item>
              </NavDropdown> */}

              <a target="_blank" rel="noreferrer" href="https://drive.google.com/file/d/1TPl2Izfnanex_89Oke39ck9A27UPGXdB/view?usp=share_link">
                <button className="btn ms-2">Resume</button>
              </a>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </section>
  );
};
